import { type ReactNode } from "react";
import { Link, useLocation, useResolvedPath } from "react-router";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isFalsy } from "@vega-core/utils/isFalsy";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  label?: string;
  icon: ReactNode;
  route: string;
  disabled?: boolean;
  className?: string;
};

export const NavigationButton = ({
  label,
  icon,
  route,
  disabled,
  className,
}: Props) => {
  const location = useLocation();
  const path = useResolvedPath(route);

  const isSelected = isFalsy(disabled) && location.pathname === path.pathname;

  return (
    <Link
      aria-label={label}
      className={cnTwMerge(
        "flex items-center xs:justify-center md:justify-start gap-3 p-4 rounded-lg no-underline h-12 text-text/primary",
        {
          "bg-background/component/10": isSelected,
          "hover:bg-background/component/10": !isSelected && isFalsy(disabled),
          "cursor-auto": isTruthy(disabled),
        },
        className,
      )}
      onClick={(e) => isTruthy(disabled) && e.preventDefault()}
      title={label}
      to={isTruthy(disabled) ? "#" : route}
    >
      <div
        className={cnTwMerge("w-6 h-6 flex items-center justify-center", {
          "text-text/primary": isSelected,
          "text-text/secondary": !isSelected,
        })}
      >
        {icon}
      </div>

      {isTruthy(label) && (
        <span
          className={cnTwMerge("block", {
            "body-base-semibold": isSelected,
            "body-base-medium": !isSelected,
          })}
        >
          {label}
        </span>
      )}
    </Link>
  );
};
